export default {
  data () {
    return {
      maxLengthOfTags: 30
    }
  },
  methods: {
    labelFormatter (label) {
      if (this.maxLengthOfTags && label.length > this.maxLengthOfTags) {
        return `${label.substring(0, this.maxLengthOfTags)}...`
      } else {
        return label
      }
    },
    showTooltip (label) {
      /* show tooltips if:
         - maxLength was set AND tooltip prop is true
         - maxLength was set AND tooltip prop is not set (null)
       */
      if (this.maxLengthOfTags && label.length > this.maxLengthOfTags) {
        return true
      } else {
        return false // default
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/mixins/TooltipHelper.js